import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { PaginationInfo } from "components/CRPComponents/Tables/GenericTable/types";

export const GET_ALL_QUERY = print(gql`
  query EducationalGroups($page: Int, $perPage: Int, $search: String) {
    EducationalGroups(page: $page, perPage: $perPage, search: $search) {
      items {
        id
        title
        groupBy
      }
      paginationInfo {
        page
        perPage
        hasMore
        totalPages
        totalData
        nextPage {
          page
          perPage
        }
      }
    }
  }
`);

export interface GetAllItem {
  id: number;
  title: string;
  groupBy: string;
}

export interface GetAllGql {
  EducationalGroups: {
    items: GetAllItem[];
    paginationInfo: PaginationInfo;
  };
}
